import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedVideos from './components/FeaturedVideos';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '桃子视频是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '桃子视频是一个数字系列视频聚合平台，涵盖91视频、97视频、51视频、92视频、98视频、小蓝视频、妖精视频等七大平台，提供电影、电视剧、动漫、综艺、纪录片等海量高清影视资源免费在线观看。',
        },
      },
      {
        '@type': 'Question',
        name: '桃子视频需要付费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '桃子视频所有内容均免费提供，用户无需注册或付费即可在线观看高清视频。我们致力于让每一位用户都能享受优质的观影体验。',
        },
      },
      {
        '@type': 'Question',
        name: '视频播放会卡顿吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '桃子视频采用先进的CDN加速技术，支持4K超清和1080P高清画质，加载速度快，播放流畅不卡顿。小蓝视频等平台更是以极速加载著称。',
        },
      },
      {
        '@type': 'Question',
        name: '有哪些视频分类？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '桃子视频涵盖91视频、97视频、51视频、92视频、98视频、小蓝视频、妖精视频七大数字系列平台，内容覆盖电影、电视剧、动漫、综艺、纪录片、动作片、悬疑片、古装剧、校园剧等多种类型。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="首页"
        description="桃子视频🎯数字系列视频平台，91视频、97视频、📌51视频等热门资源免费高清在线看，电视剧电影全集不缓冲，涵盖92视频、98视频、小蓝视频、妖精视频全系列。"
        keywords="桃子视频,91视频,97视频,51视频,91视频网站,92视频,98视频,小蓝视频,妖精视频,在线观看,高清电影,电视剧"
        canonicalUrl="https://taozivideo.com/"
        schema={schema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedVideos />
        <LatestArticles />
      </main>
      <Footer />
    </>
  );
}